import { render, staticRenderFns } from "./Humor.vue?vue&type=template&id=ec43d6fe"
import script from "./Humor.vue?vue&type=script&lang=js"
export * from "./Humor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports